import { create } from "zustand";
import ApiService from "../../API/apiService";
import { API_ENDPOINTS } from "../../API/endpoints";
import { handleApiError } from "../../utils/CommonFunctions";

export const useChannelStore = create((set) => ({
  channelData: null,
  loading: false,
  error: null,
  channelMembers: [],

  /**
   * Fetches channel details and updates the store.
   * @param {string} channelId - ID of the user to fetch data for.
   */


  updateChannelData: (data) => {
    set({ channelData: data });
  },
  getChannelDetails: async (channelId) => {
    set({ loading: true, error: null });

    try {
      // Call the API
      const response = await ApiService.get(
        `${API_ENDPOINTS.getChannelById}/${channelId}`
      );

      // Check response and update state
      if (response.status === 1) {
        set({ channelData: response.data });
      } else {
        set({ error: "Failed to fetch user details" });
      }
    } catch (err) {
      handleApiError(err);
      set({ error: err.message || "Unknown error" });
    } finally {
      set({ loading: false });
    }
  },

  getChannelMembers: async (channelId) => {
    set({ loading: true, error: null });

    try {
      // Call the API
      const response = await ApiService.get(
        `${API_ENDPOINTS.getChannelMembers}/${channelId}`
      );

      // Check response and update state
      if (response.status === 1) {
        set({ channelMembers: response.data });
      } else {
        set({ error: "Failed to fetch user details" });
      }
    } catch (err) {
      handleApiError(err);
      set({ error: err.message || "Unknown error" });
    } finally {
      set({ loading: false });
    }
  },

}));